import React from 'react';
import {
  BreadcrumbBar,
  StagePill,
  PillCount,
} from './LiveMeetingsDashboard.styles';

const FILTER_PILLS = [
  { key: 'approval_pending', label: 'Approval', icon: '⏳', variant: 'attention' },
  { key: 'scheduled',        label: 'Scheduled', icon: '📅', variant: 'default'   },
  { key: 'needs_triage',     label: 'Triage',    icon: '⚠️', variant: 'attention' },
  { key: 'failed',           label: 'Failed',    icon: '✗',  variant: 'danger'    },
];

export default function PipelineBreadcrumb({ stageCounts, selectedStages, onToggleStage, onClearFilter }) {
  const totalCount = stageCounts.all || 0;
  const allSelected = !selectedStages || selectedStages.length === 0;

  return (
    <BreadcrumbBar>
      <StagePill
        $variant="all"
        $selected={allSelected}
        onClick={onClearFilter}
        title="Show all meetings"
      >
        All <PillCount>{totalCount}</PillCount>
      </StagePill>

      {FILTER_PILLS.map(({ key, label, icon, variant }) => {
        const count    = stageCounts[key] || 0;
        const selected = !allSelected && selectedStages.includes(key);

        return (
          <StagePill
            key={key}
            $variant={selected ? undefined : (count === 0 ? 'empty' : variant)}
            $selected={selected}
            onClick={() => onToggleStage(key)}
            title={`${label} (${count})`}
          >
            {icon} {label} <PillCount>{count}</PillCount>
          </StagePill>
        );
      })}
    </BreadcrumbBar>
  );
}
